import { RuntimeSlideModel } from '../slides/models';
import { SlideScheduleService } from '../slides/slide-schedule.service';
import { InterruptSource } from './enums';

/** Two fixed slots, so an interrupt replaces only its own kind and a live stream never discards the scheduled one. */
export class Interrupts {
  private live?: RuntimeSlideModel;
  private scheduled?: RuntimeSlideModel;

  public constructor(private readonly schedule: SlideScheduleService) { }

  public put(slide: RuntimeSlideModel, source: InterruptSource): void {
    this[source] = slide;
  }

  public active(now: number): { slide: RuntimeSlideModel; source: InterruptSource } | null {
    // Order is the priority rule: a live stream outranks a scheduled video for as long as it is running.
    for (const source of [InterruptSource.Live, InterruptSource.Scheduled] as const) {
      const slide = this[source];

      // Dropped on read, so an expired interrupt cannot return once the one above it ends.
      if (slide?.meta.expiresAt !== undefined && slide.meta.expiresAt <= now) {
        this[source] = undefined;
      }

      if (slide && this.schedule.isEligible(slide, now)) {
        return { slide, source };
      }
    }

    return null;
  }

  public remove(source: InterruptSource): void {
    this[source] = undefined;
  }

  public clear(): void {
    this.live = undefined;
    this.scheduled = undefined;
  }
}
